export const FJVideoRemoveBgDataConfig = {
    FORMATE_LIST: ['video', 'gif'],

    SUPPORTED_VIDEO_FORMATS: [
        'video/mp4',
        'video/webm',
        'video/x-matroska', // MKV
        'video/3gpp', // 3GP
        'video/quicktime', // MOV
        'video/x-m4v', // M4V
        'video/3gpp2', // 3G2
    ],
    ACCEPT_FILE_TYPE: '.mp4,.mkv,.3gp,.mov,.webm,.m4v,.3g2',
};
